import React from 'react'

import { FormBuilderV3, WebViewActionStrip } from '@acorns/web-components'
import styled from 'styled-components'

import Spinner from 'components/Spinner'
import { withTrackClicked } from 'components/trackers'
import { CenteredContentContainer } from 'pages/spend/direct-deposit/SharedComponents'
import {
  Container,
  Field,
  FieldName,
  FieldRow,
  FieldValue,
  FieldsContainer,
  FormContainer,
  GreenText,
  InfoBlock,
  LockIcon,
  ProgressBar,
  SectionTitle,
  StyledButton,
} from 'pages/spend/direct-deposit/WebViewComponents'
import { PageAnalytics } from 'utils/analytics'
import { SPINNER } from 'utils/testing/testIDs'

import { WVProps } from '../types'
import enhance from './enhance'

const StickyEmailButton = styled(StyledButton)`
  &&& {
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 30px;
    margin: 20px 20px 0;
    width: calc(100% - 40px);
  }
`

export const EmailButton = withTrackClicked<any, any>((props) => ({
  object_name: 'directDepositPDFCTA',
  screen: 'directDepositPDF',
  screen_name: 'directDepositPDF',
  platform: 'mobile',
  cta_title: 'Email me my form',
  employer_name: props.employerName,
}))(StickyEmailButton)

const Page: React.SFC<WVProps> = (props: WVProps) => (
  <>
    {!props.data.loading && <PageAnalytics />}

    {props.data.loading && (
      <CenteredContentContainer data-testid={SPINNER}>
        <Spinner />
      </CenteredContentContainer>
    )}

    {!props.data.loading && (
      <Container>
        <WebViewActionStrip
          title={'Review Employer Info'}
          action={{
            onClick: props.handleWebViewBack,
            shouldShowCloseIcon: false,
          }}
          link={{ onClick: props.handleWebViewExit, text: 'Cancel' }}
        />

        <ProgressBar progress={100} />

        <InfoBlock>Confirm your information.</InfoBlock>

        <SectionTitle>Who Is Your Employer?</SectionTitle>

        <FormContainer padding="15px 20px">
          <FormBuilderV3
            errors={props.errors}
            rows={props.employerInfoRows}
            values={props.values}
            handleChange={props.handleChange}
            handleSelectChange={props.handleSelectChange}
            loading={false}
          />
        </FormContainer>

        {props.hasDirectDepositFlowImprovements === false && (
          <>
            <SectionTitle>
              Account Information <LockIcon />
            </SectionTitle>

            <FieldsContainer>
              <FieldRow>
                <Field>
                  <FieldName>Deposit Percentage</FieldName>
                  <FieldValue>
                    <GreenText>100%</GreenText>
                  </FieldValue>
                </Field>
                <Field>
                  <FieldName>Deposit to:</FieldName>
                  <FieldValue>
                    {'Spend Account - '}
                    <GreenText>{props.balance}</GreenText>
                  </FieldValue>
                </Field>
              </FieldRow>
            </FieldsContainer>
          </>
        )}

        <EmailButton
          onPress={props.handleEmailMyPDF}
          secondary={false}
          disabled={!props.isValid}
          employerName={props.values && props.values.name}
        >
          {props.processing ? (
            <Spinner height={40} width={40} white={true} />
          ) : props.hasDirectDepositFlowImprovements &&
            props.hasMobileDirectDepositJSBridge ? (
            'Email or Print'
          ) : (
            'Email me my Form'
          )}
        </EmailButton>
      </Container>
    )}
  </>
)

export default enhance(Page)
export { enhance, Page }
